import { render, staticRenderFns } from "./KeywordPlannerResultList.vue?vue&type=template&id=36ae588b"
import script from "./KeywordPlannerResultList.vue?vue&type=script&lang=js"
export * from "./KeywordPlannerResultList.vue?vue&type=script&lang=js"
import style0 from "./KeywordPlannerResultList.vue?vue&type=style&index=0&id=36ae588b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports